import { FC, ReactNode } from 'react';

export const FaqLayout: FC<{ head: ReactNode; children: ReactNode }> = ({
  head,
  children,
}) => {
  return (
    <div className="mt-6 flex flex-col gap-6 px-5 pb-12 xl:px-[30px]">
      {head}
      {children}
    </div>
  );
};
